import React, { useState } from "react";
import { Button } from "../ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { handoverApi } from "./handoverApi";

export const BulkAssignBar = ({ siteId, selected, dwellings, developers, onDone }) => {
  const [developerId, setDeveloperId] = useState("");
  const [saving, setSaving] = useState(false);
  if (!selected.length || !developers.length) return null;

  const assign = async () => {
    const replacing = dwellings.filter((d) => selected.includes(d.id) && d.client
      && !(d.client.client_type === "developer" && d.client.developer_id === developerId));
    if (replacing.length && !window.confirm(`${replacing.length} selected dwelling(s) already have a different client. Replace them with this developer?`)) return;
    setSaving(true);
    try {
      const r = await handoverApi(`/sites/${siteId}/assign-developer`, { method: "POST", body: { developer_id: developerId, dwelling_ids: selected } });
      toast.success(`Developer assigned to ${r.assigned} dwelling(s)`);
      if (r.skipped.length) toast.warning(`Skipped (open walkthrough): ${r.skipped.join(", ")}`);
      onDone();
    } catch (e) {
      toast.error(e.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="my-3 flex flex-col sm:flex-row sm:items-center gap-2 rounded-lg bg-amber-50 border border-amber-200 p-3" data-testid="bulk-assign-bar">
      <span className="text-sm font-semibold text-amber-900 shrink-0" data-testid="bulk-selected-count">{selected.length} selected</span>
      <Select value={developerId} onValueChange={setDeveloperId}>
        <SelectTrigger className="sm:w-72 bg-white" data-testid="bulk-developer-select"><SelectValue placeholder="Assign a developer…" /></SelectTrigger>
        <SelectContent>
          {developers.map((d) => <SelectItem key={d.id} value={d.id}>{d.company_name} — {d.name}</SelectItem>)}
        </SelectContent>
      </Select>
      <Button size="sm" disabled={!developerId || saving} onClick={assign} className="btn-construction" data-testid="bulk-assign-button">
        {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : "Assign to selected"}
      </Button>
    </div>
  );
};
